if (window.Cypress) {
  // eslint-disable-next-line no-underscore-dangle
  window.__REACT_DEVTOOLS_GLOBAL_HOOK__ =
    // eslint-disable-next-line no-underscore-dangle
    window.parent.__REACT_DEVTOOLS_GLOBAL_HOOK__;
}
